import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { useAuth } from './AuthContext';
import api from '../services/api';

const OrgContext = createContext();

export function OrgProvider({ children }) {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState([]);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOrgs = useCallback(async () => {
    if (!user) {
      setOrgs([]);
      setCurrentOrg(null);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get('/crm-orgs');
      const items = res.data.items || [];
      setOrgs(items);
      const stored = localStorage.getItem('crm_org_id');
      const found = items.find(o => o.id === stored);
      if (found) {
        setCurrentOrg(found);
      } else if (items.length > 0) {
        const defaultOrg = items.find(o => o.is_default) || items[0];
        setCurrentOrg(defaultOrg);
        localStorage.setItem('crm_org_id', defaultOrg.id);
      }
    } catch {
      // Not authenticated
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchOrgs();
  }, [fetchOrgs]);

  const switchOrg = useCallback((orgId) => {
    const org = orgs.find(o => o.id === orgId);
    if (org) {
      setCurrentOrg(org);
      localStorage.setItem('crm_org_id', orgId);
      window.location.reload();
    }
  }, [orgs]);

  const refreshOrgs = useCallback(async () => {
    await fetchOrgs();
  }, [fetchOrgs]);

  return (
    <OrgContext.Provider value={{ orgs, currentOrg, loading, switchOrg, refreshOrgs }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (!ctx) throw new Error('useOrg must be used within OrgProvider');
  return ctx;
}
